
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishers",
      function () {
        return require("private-next-pages/publishers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishers"])
      });
    }
  